import { render, staticRenderFns } from "./nearexpiration.vue?vue&type=template&id=1b6fb12c&scoped=true&"
import script from "./nearexpiration.vue?vue&type=script&lang=js&"
export * from "./nearexpiration.vue?vue&type=script&lang=js&"
import style0 from "./nearexpiration.vue?vue&type=style&index=0&id=1b6fb12c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6fb12c",
  null
  
)

export default component.exports